import PropTypes from "prop-types";

import ApiKeyManagement from "../../../settings/ApiKeyManagement";

import useExplorerLayoutContext from "../../../../helpers/contexts/explorerLayout";

const ApiKeys = ({ isAdmin, accountId }) => {
  const { activateSnackbar } = useExplorerLayoutContext();

  return (
    <ApiKeyManagement
      tier="tier-2"
      accountId={accountId}
      isAdmin={isAdmin}
      activateSnackbar={activateSnackbar}
      title="Aclymate Agent Access — Tier-2"
      analyticsEventPrefix="explorer_api_key"
    />
  );
};

ApiKeys.propTypes = {
  isAdmin: PropTypes.bool,
  accountId: PropTypes.string
};

export default ApiKeys;
